import { render, staticRenderFns } from "./HorizontalWorkflowJobTabs.vue?vue&type=template&id=f25b90b4&"
import script from "./HorizontalWorkflowJobTabs.vue?vue&type=script&lang=ts&"
export * from "./HorizontalWorkflowJobTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports